/**
 * Created by calhosh on 7/13/2017.
 */
import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import {Slider, Rail, Handles, Tracks, Ticks} from 'react-compound-slider';
import {TooltipRail, Handle, Track} from './components';
import styled from 'styled-components';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import {labels} from '../../../util/utils';
import uuidv4 from 'uuid/v4';
import MotifTextLink from '@ey/motif-react-wrapper/TextLink';

const ReactSlider = forwardRef((props, ref) => {
	const {
		defaultValue,
		value,
		bodyId,
		StyleName,
		disabled,
		isViewBodyOnly,
		isTrackChanges = false,
		onChange,
		aresSlider
	} = props;

	const domain = [1, value.length];

	const [deselect, setDeselect] = useState(false);
	const [tooltipText, setTooltipText] = useState(defaultValue.label);

	const bodyValues = value.map(function(item) {
		return item.bodyOptionText;
	});
	const bodyOptionIds = value.map(function(item) {
		return item.bodyOptionId;
	});
	var labelValue =
		defaultValue !== 0 ? bodyOptionIds.indexOf(defaultValue.value) + 1 : Math.floor((1 + value.length) / 2);

	const onSlideEnd = (value, evt) => {
		var toUpdate = bodyOptionIds[value - 1];
		onChange && onChange(toUpdate);
	};

	const handleOnLinkClick = (evt) => {
		if (disabled) {
			evt.preventDefault();
			evt.stopPropagation();
			return false;
		}

		onSlideEnd(index + 1, evt);
	};

	useImperativeHandle(ref, () => ({
		onResponseCompleted(labelText) {
			setTooltipText(labelText);
		}
	}));

	useEffect(() => {
		if (!isTrackChanges) {
			if (Object.keys(defaultValue).length > 0) {
				document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-handles')[0]
					.classList.remove('hideSelectorforAnswer');
				document
					.getElementById(bodyId)
					.querySelectorAll('section.railCenterStyle')[0]
					.classList.remove('deselectSelectorforAnswer');
				document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-ticks')[0]
					.classList.remove('deselectSelectorforTicks');
				let x = document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-ticks')[0]
					.querySelectorAll('section.tickSlider');
				let i;
				for (i = 0; i < x.length; i++) {
					x[i].classList.remove('deselectSelectorforAnswer');
				}
				setDeselect(false);
			} else {
				document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-handles')[0]
					.classList.add('hideSelectorforAnswer');
				document
					.getElementById(bodyId)
					.querySelectorAll('section.railCenterStyle')[0]
					.classList.add('deselectSelectorforAnswer');
				document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-ticks')[0]
					.classList.add('deselectSelectorforTicks');
				let x = document
					.getElementById(bodyId)
					.querySelectorAll('div.slider-ticks')[0]
					.querySelectorAll('section.tickSlider');
				let i;
				for (i = 0; i < x.length; i++) {
					x[i].classList.add('deselectSelectorforAnswer');
				}
				setDeselect(true);
			}
		}
	}, [bodyId, defaultValue]);

	return (
		<>
			<StyleDeSelectText className="StyleDeSelectText">
				{deselect && !isViewBodyOnly && <div className="text-deselect">{labels.sliderDeSelectMessage}</div>}
			</StyleDeSelectText>
			<StyleSlider
				mode={1}
				step={1}
				domain={domain}
				className={StyleName}
				onSlideEnd={(e) => onSlideEnd(e)}
				onSlideStart={() => setTooltipText('')}
				onChange={() => setTooltipText('')}
				values={[labelValue]}
				disabled={disabled}
			>
				<Rail>
					{(railProps) => (
						<TooltipRail {...railProps} labelValue={labelValue} val={bodyValues} aresSlider={aresSlider} />
					)}
				</Rail>
				<Handles>
					{({handles, activeHandleID, getHandleProps}) => (
						<div className="slider-handles">
							{handles.map((handle) => (
								<Handle
									key={handle.id}
									handle={handle}
									val={tooltipText}
									domain={domain}
									isActive={handle.id === activeHandleID}
									getHandleProps={getHandleProps}
									disabled={!defaultValue?.label?.length || disabled}
									isViewBodyOnly={isViewBodyOnly}
									aresSlider={aresSlider}
								/>
							))}
						</div>
					)}
				</Handles>
				<Tracks left={false} right={false}>
					{({tracks, getTrackProps}) => (
						<div className="slider-tracks">
							{tracks.map(({id, source, target}) => (
								<Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
							))}
						</div>
					)}
				</Tracks>
				<Ticks key={uuidv4()} values={bodyValues} count={value.length}>
					{({ticks}) => (
						<div className="slider-ticks">
							{ticks.map((tick, index) => (
								<TicksWrapper
									key={index}
									style={{
										width: `${
											index === ticks.length - 1
												? 100 / (ticks.length - 1) - 0.5
												: index === 0
												? 100 / (ticks.length - 1) + 0.5
												: 100 / (ticks.length - 1)
										}%`,
										left: `${
											index === ticks.length - 1
												? index * (100 / (ticks.length - 1)) - 100 / (ticks.length - 1) + 0.5
												: index * (100 / (ticks.length - 1))
										}%`
									}}
								>
									<MotifTextLink href="#" disabled={disabled} onClick={handleOnLinkClick}>
										<section className="tickSlider" />
									</MotifTextLink>
									<section className={`tickSliderValue ${isViewBodyOnly ? 'tickSliderValue' : ''}`}>
										<EllipseControl
											content={tick.value}
											tooltip={tick.value}
											noOfLines={2}
											tooltipClass="tooltipCustomWidth"
										/>
									</section>
								</TicksWrapper>
							))}
						</div>
					)}
				</Ticks>
			</StyleSlider>
		</>
	);
});

ReactSlider.displayName = 'ReactSlider';

export default ReactSlider;

const StyleDeSelectText = styled.section`
	text-align: center;
	margin-top: var(--px-15);
	line-height: normal;
	color: var(--neutrals-900);
`;

const StyleSlider = styled(Slider)`
	position: relative;
	width: 100%;
	top: var(--px-15);
	height: var(--px-40);
	.slider-ticks {
		position: relative;
	}
`;
const TicksWrapper = styled.section`
	.hideSelectorforAnswer {
		display: none;
	}
	position: absolute;
	display: inline-flex;
	.motif-text-link {
		align-items: flex-start !important;
		position: static !important;
	}
	.tickSlider {
		position: absolute;
		margin-top: calc(var(--px-10) * -1);
		width: var(--px-2);
		height: var(--px-18);
		background-color: var(--neutrals-300);
	}
	.tickSliderValue {
		display: none;
	}
	&:first-child {
		.tickSlider {
			left: 0;
		}
		.tickSliderValue {
			display: flex;
			line-height: normal;
			margin-top: var(--px-10);
			margin-left: var(--px-4);
			width: var(--px-133);
			font-size: var(--px-12);
		}
	}
	&:last-child {
		justify-content: flex-end;
		.tickSlider {
			right: 0;
		}
		.tickSliderValue {
			display: flex;
			line-height: normal;
			justify-content: flex-end;
			width: var(--px-133);
			margin-top: var(--px-10);
			text-align: right;
			font-size: var(--px-12);
			margin-right: var(--px-4);
		}
	}
	.tickSliderValueView {
		display: none !important;
	}
	.selectedValue {
		display: block !important;
	}
`;
